import React, { useState, useEffect } from 'react';
import api from '../../../api';
import { Redirect } from 'react-router-dom';
import MenuHorizontal from '../../layouts/MenuHorizontal';
import MenuVertical from '../../layouts/MenuVertical';
import { Icon } from 'semantic-ui-react';
import { CabecalhoForm, OpcaoForm } from '../../layouts/FormUI';
import * as FormValidator from '../../../utils/formValidator';
import EditarVotacaoSobre from './EditarVotacaoSobre';
import EditarVotacaoPerguntas from './EditarVotacaoPerguntas';
import EditarVotacaoRelatorios from './EditarVotacaoRelatorios';
import EditarVotacaoResultado from './EditarVotacaoResultado';
import ModalFinalizarVotacao from './ModalFinalizarVotacao';

import './EditarVotacao.css';

const ACOES_VALIDAS = ['sobre', 'perguntas', 'resultados', 'relatorios'];

const EditarVotacao = ({ match, history }) => {
  const [activeItem, setActiveItem] = useState('sobre');
  const [errors, setErrors] = useState({});
  const [condominio, setCondominio] = useState({});
  const [votacao, setVotacao] = useState({});
  const [votacaoPossuiVoto, setVotacaoPossuiVoto] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(
    () => {
      const init = async () => {
        try {
          if (match.params.action && ACOES_VALIDAS.indexOf(match.params.action) !== -1) {
            setActiveItem(match.params.action);
          }

          setCondominio(await api.condominio.findSimpleById(match.params.condominioId));
          setVotacao(await api.votacao.findForEdit(match.params.id));
          setVotacaoPossuiVoto(await api.votacao.checkPossuiVoto(match.params.id).then(it => it.possuiVotos));
        } catch(e) {
          setErrors((e.data && e.data.errors) || {});
        }

        setLoading(false);
      };
      init();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const updateVotacao = dados => setVotacao(p => ({ ...p, ...dados }));

  const disabledFields = () => votacaoPossuiVoto || !!votacao.votacaoFinalizada;

  const handleItemClick = (_, { name }) => {
    const path = history.location.pathname.replace(activeItem, name);
    setActiveItem(name);

    if (match.params.action && match.params.action !== name) {
      if (path === history.location.pathname) {
        history.push(`${path}/${name}`);
      } else {
        history.push(`${path}`);
      }
    }
  };

  const onChangeVotacaoIniciada = async (_, { checked }) => {
    if (FormValidator.isVazio(votacao.titulo)) {
      setErrors({ titulo: 'Digite um título para a votação' });
    } else {
      setLoading(true)
      try {
        const result = await api.votacao.iniciarVotacaoV2(votacao._id, { condominio: condominio._id, votacaoIniciada: checked });
        updateVotacao(result);
      } catch (e) {
        setErrors((e.data && e.data.errors) || {});
      }
      setLoading(false);
    }
  };

  const ABAS = [
    ['sobre', 'calendar check outline', 'Sobre a reunião'],
    ['perguntas', 'question', 'Perguntas / pautas'],
    ['resultados', 'tasks', 'Resultados'],
    ['relatorios', 'file alternate outline', 'Relatórios'],
  ];
  const voltar = `/condominios/${match.params.condominioId}/votacoes`;

  return (
    <>
      {!!errors.global && <Redirect to="/" />}
      <MenuHorizontal />
      <div className="corpo-dashboard">
        <MenuVertical condominio={condominio} />
        <div className="va-imp-pagina">
          <CabecalhoForm
            voltar={voltar}
            voltarTexto="Votações"
            titulo={votacao.titulo ? `Votação · ${votacao.titulo}` : 'Votação'}
            descricao="Edite a reunião e as pautas, acompanhe os resultados e emita os relatórios."
          />

          <div className="va-votacao-controles">
            {votacao.votacaoFinalizada ? (
              <OpcaoForm ativa={votacao.votacaoIniciada} disabled onChange={() => {}} titulo="Votação finalizada" descricao="A votação foi encerrada e não pode mais ser reaberta." />
            ) : (
              <OpcaoForm
                name="votacaoIniciada"
                ativa={votacao.votacaoIniciada}
                disabled={loading}
                onChange={e => onChangeVotacaoIniciada(e, { checked: e.target.checked })}
                titulo={votacao.votacaoIniciada ? 'Votação liberada' : 'Votação bloqueada'}
                descricao="Ligado: os moradores podem votar. Desligado: a votação fica bloqueada para todos."
              />
            )}
            <ModalFinalizarVotacao
              disabled={!!votacao.votacaoFinalizada}
              votacao={votacao}
              loadingVotacao={loading}
              condominio={condominio}
              updateVotacao={updateVotacao}
            />
          </div>

          <nav className="va-abas-votacao" role="tablist" aria-label="Seções da votação">
            {ABAS.map(([nome, icone, rotulo]) => (
              <button
                key={nome}
                type="button"
                role="tab"
                aria-selected={activeItem === nome}
                aria-label={rotulo}
                className={activeItem === nome ? 'ativo' : ''}
                onClick={e => handleItemClick(e, { name: nome })}
              >
                <Icon name={icone} /> <span>{rotulo}</span>
              </button>
            ))}
          </nav>
          <div>
            <EditarVotacaoSobre
              visible={activeItem === 'sobre'}
              loadingVotacao={loading}
              votacao={votacao}
              condominio={condominio}
              votacaoPossuiVoto={votacaoPossuiVoto}
              updateVotacao={updateVotacao}
            />
            <EditarVotacaoPerguntas
              visible={activeItem === 'perguntas'}
              votacao={votacao}
              condominio={condominio}
              votacaoPossuiVoto={votacaoPossuiVoto}
              handleItemClick={handleItemClick}
              disabledFields={disabledFields}
            />
            <EditarVotacaoResultado
              visible={activeItem === 'resultados'}
              votacao={votacao}
              condominio={condominio}
              history={history}
            />
            <EditarVotacaoRelatorios
              visible={activeItem === 'relatorios'}
              votacao={votacao}
              condominio={condominio}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditarVotacao;
